var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.054,
    height: 26.665,
    viewBox: "0 0 17.054 26.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-4 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #7d7d7d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11279",
    "data-name": "Group 11279",
    transform: "translate(-56.75 -108.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    className: "cls-1",
    d: "M4.412,17.081V20.6l7.76-2.03v-3.35h0A7.811,7.811,0,0,0,8.36.6,7.818,7.818,0,0,0,4.446,15.152",
    transform: "translate(56.9 108.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1074",
    "data-name": "Line 1074",
    className: "cls-2",
    y1: 2,
    x2: 7.7,
    transform: "translate(61.429 129.667)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1771",
    "data-name": "Ellipse 1771",
    className: "cls-3",
    cx: 2.232,
    cy: 2.232,
    rx: 2.232,
    ry: 2.232,
    transform: "translate(63.036 114.247)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1075",
    "data-name": "Line 1075",
    className: "cls-2",
    y1: 2,
    x2: 7.7,
    transform: "translate(61.429 132)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1356",
    "data-name": "Line 1356",
    className: "cls-4",
    y2: 6.071,
    transform: "translate(65.357 121.679)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightCover);
export default __webpack_public_path__ + "static/media/lightCover.da5e4b38e4deabe0563bcafce2c25f1d.svg";
export { ForwardRef as ReactComponent };